import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import ClientList from '../views/ClientList.vue'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

export const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: '/clients',
        meta: {
            admin: true
        }
    },
    {
        path: '/calendar',
        component: () => import(/* webpackChunkName: "calendar" */ '../views/Calendar.vue'),
        meta: {
            admin: true,
            icon: 'mdi-calendar',
            caption: 'calendar'
        }
    },
    {
        path: '/clients',
        name: 'ClientList',
        component: ClientList,
        meta: {
            admin: true,
            caption: 'clients',
            icon: 'mdi-calendar'
        }
    },
    {
        path: '/clients/:id',
        component: () => import(/* webpackChunkName: "clients" */ '../views/Client.vue'),
        meta: {
            hidden: true,
            admin: true
        }
    },
    {
        path: '/timesheets',
        component: () => import(/* webpackChunkName: "timesheets" */ '../views/Timesheets.vue'),
        meta: {
            caption: 'timesheets',
            icon: 'mdi-calendar'
        }
    },
    {
        path: '/projects',
        component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
        meta: {
            admin: true,
            caption: 'projects',
            icon: 'mdi-folder-multiple'
        }
    },
    {
        path: '/settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
        meta: {
            admin: true,
            caption: 'settings',
            icon: 'mdi-cog'
        }
    },
    {
        path: '/users',
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
        meta: {
            admin: true,
            caption: 'users',
            icon: 'mdi-account-multiple'
        }
    },
    {
        path: '/login',
        component: Login,
        meta: {
            hidden: true
        }
    },
    {
        path: '/profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
        meta: {
            caption: 'profile',
            icon: 'mdi-account',
            admin: true
        }
    },
    {
      path: '/oauth/:service',
      name: 'OAuth',
      component: () => import(/* webpackChunkName: "oauth" */ '../views/OAuthLogin.vue'),
      meta: {
        hidden: true,
      }
    },
    {
        path: '/payroll',
        name: 'payroll',
        component: () => import(/* webpackChunkName: "payroll" */ '../views/payroll/PayrollListing.vue'),
        meta: {
            caption: 'payroll',
            icon: 'mdi-account',
            admin: true,
            scopes: ['payroll']
        }
    },
    {
        path: '/logs',
        name: 'logs',
        component: () => import(/* webpackChunkName: "payroll" */ '../views/Logs.vue'),
        meta: {
            caption: 'logs',
            icon: 'mdi-list-box',
            admin: true,
            scopes: ['admin']
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to: Route, from: Route, next: any) => {
    if (to.path === '/login') {
        if (store.state.account) {
            return next('/clients');
        }

        next();
        return;
    }

    if (to.path.indexOf('/oauth') === 0) {
        next();
        return;
    }

    if (!store.state.account && to.path !== '/login') {
        next('/login');
        return;
    }

    // CASE: if route requires admin access, prevent routing and stay on current page
    if (to.meta.admin && (!store.state.account || !store.state.account.scopes.includes('admin'))) {
        return next('/timesheets');
    }

    store.commit("TITLE_BAR", '')
    store.commit("TITLE_ITEMS", null)
    next();
});

export default router
